import { createContext, useContext, useState } from "react";

const UIContext = createContext();

export function useUIContext() {
  return useContext(UIContext);
}

export const UIConsumer = UIContext.Consumer; // TODO: Need to use proper consumer

export function UIProvider({ children }) {
  const [customCounty, setCustomCounty] = useState("");
  const [customCity, setCustomCity] = useState("");
  const [requiredLengthBilling, setRequiredLengthBilling] = useState(17);
  const [requiredLengthShipping, setRequiredLengthShipping] = useState(17);
  const [requiredLength, setRequiredLength] = useState(15);
  const value = {
    requiredLengthBilling: requiredLengthBilling,
    setRequiredLengthBilling: setRequiredLengthBilling,
    requiredLengthShipping: requiredLengthShipping,
    setRequiredLengthShipping: setRequiredLengthShipping,
    requiredLength: requiredLength,
    setRequiredLength: setRequiredLength,
    customCounty,
    setCustomCounty,
    customCity,
    setCustomCity,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}
